import {
  getActionDescription,
  getApiActionsWithPayload,
} from '@binotel-frontend/bnt-common-components';
import {
  ESubjectType,
  ISubjectFavoritesStatus,
  ISyncStatusProgress,
} from '@entities/subject';
import {createAction, props} from '@ngrx/store';
import {IBranchDossier} from '@shared/entities/branch-dossier/branch-dossier.interfaces';

const desc = getActionDescription('Branch');

export namespace BranchActions {
  export const getBranch = getApiActionsWithPayload(
    desc('Get branch'),
    props<{branchId: string}>(),
    props<{payload: IBranchDossier}>()
  );
  export const getBranchFavorites = getApiActionsWithPayload(
    desc('Get Branch Favorites'),
    props<{subjectId: number}>(),
    props<{payload: ISubjectFavoritesStatus}>()
  );
  export const markFavorite = createAction(
    desc('Mark as favorite'),
    props<{payload: ISubjectFavoritesStatus}>()
  );
  export const markFavoriteFailed = createAction(
    desc('Mark as favorite failed')
  );
  export const unmarkFavorite = createAction(
    desc('Unmark as favorite'),
    props<{payload: ISubjectFavoritesStatus}>()
  );
  export const unmarkFavoriteFailed = createAction(
    desc('Unmark as favorite failed')
  );
  export const branchSync = getApiActionsWithPayload(
    desc('Sync branch'),
    props<{
      subjectId: number;
      code: string | null;
      subjectType: ESubjectType;
    }>(),
    props<{payload: ISyncStatusProgress}>()
  );
  export const clearBranch = createAction(desc('Clear Branch'));
  export const resetBranchStatus = createAction(desc('Reset branch status'));
  export const resetFavorites = createAction(desc('Reset favorites'));
}
